// extracted by mini-css-extract-plugin
module.exports = {"Search":"SearchBar_Search__32VhM","SearchIcon":"SearchBar_SearchIcon__2uHTE","SearchInput":"SearchBar_SearchInput__3TQO5"};